import { api } from './api';

export interface ChildFullProfile {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber?: string;
  schoolName?: string;
  gradeLevel?: string;
  birthYear?: number;
  councilId?: number;
  councilName?: string;
  userType: string;
  status: string;
  pendingEmail?: string;
}

export interface ChildPersonalInfoSummary {
  id: number;
  firstName: string;
  lastName: string;
  phoneNumber?: string;
  birthYear?: number;
  activeEmail: string;
  pendingEmail?: string;
  emailChangePending: boolean;
}

export interface UpdateChildPersonalInfoRequest {
  firstName: string;
  lastName: string;
  email?: string;
  phoneNumber?: string;
  birthYear?: number;
}

export interface UpdateChildSchoolRequest {
  countryId?: number;
  councilId?: number;
  councilName?: string;
  schoolName: string;
  gradeLevel: string;
  unknownSchool?: boolean;
  unknownCouncilName?: string;
}

const childEditService = {
  async getChildProfile(childId: number): Promise<ChildFullProfile> {
    const response = await api.get(`/api/parent/child/${childId}/profile`);
    if (!response.data?.success) throw new Error(response.data?.message || 'Failed to load child profile');
    return response.data.data;
  },

  async updatePersonalInfo(
    childId: number,
    request: UpdateChildPersonalInfoRequest
  ): Promise<ChildPersonalInfoSummary> {
    const response = await api.put(`/api/parent/child/${childId}/personal-info`, request);
    if (!response.data?.success) throw new Error(response.data?.message || 'Failed to update personal info');
    return response.data.data;
  },

  async cancelPendingEmail(childId: number): Promise<void> {
    const response = await api.delete(`/api/parent/child/${childId}/pending-email`);
    if (!response.data?.success) throw new Error(response.data?.message || 'Failed to cancel pending email');
  },

  async updateSchoolProfile(childId: number, request: UpdateChildSchoolRequest): Promise<void> {
    const response = await api.patch(`/api/parent/child/${childId}/school-profile`, request);
    if (!response.data?.success) throw new Error(response.data?.message || 'Failed to update school profile');
  },

  async changeChildPassword(childId: number, newPassword: string, confirmPassword: string): Promise<void> {
    const response = await api.post(`/api/parent/child/${childId}/change-password`, {
      newPassword,
      confirmPassword,
    });
    if (!response.data?.success) throw new Error(response.data?.message || 'Failed to change password');
  },
};

export default childEditService;
